import { getStateData } from "analytics/index";
import { getAndRemoveItem, getChannel } from "utils/localStorage";
import {
  EVAM_EVENT_NAMES,
  flattenData
} from "constants/AnalyticsTypeConstants";
import { calculateValidityAndExpiry, getBrowserName, userSelectedPlan, validateDOBPushEvent } from "../../utils/helpers";
import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";
import lowerCase from "lodash/lowerCase";
import { forms, JOURNEY_FLOW, ORDER_STATUS } from "utils/constants";

import {
  CONTRACT_ITEM_TYPES,
  CONTRACT_TYPES,
  paths,
  PAYMENT_STATUSES_CXOS,
  ROOT_CHANNEL,
  SIM_TYPES,
  WEB_CHANNEL
} from "utils/constants";
import Session from "session";
import { getOSInfo, isEpBind, removeSensitiveData, urlParam } from "utils/helpers";
import { getItem, setItem, getPageLoadTime } from "utils/localStorage";
import { FIELDS_TO_TRACK } from "../googleTagManager4Analytics/payloadConstructors";
import { isEmpty } from "lodash";

const timeSpentOnPageTilltheEvent = () => {
  let date1 = new Date();
  // Get the difference in milliseconds
  let diffInMs = date1 - new Date(getPageLoadTime());

  // Convert milliseconds to days, hours, minutes, and seconds
  let diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  let diffInHours = Math.floor(
    (diffInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  let diffInMinutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
  let diffInSeconds = Math.floor((diffInMs % (1000 * 60)) / 1000);
  return `${diffInDays}d-${diffInHours}h-${diffInMinutes}m-${diffInSeconds}s`;
};

const getCurrentPath = () => window.location.pathname;
const getCurrentUrl = () => window.location.origin + getCurrentPath();

const getPlanDetails = (store) => {
  const selectedPlanId = getStateData(
    store,
    "api.initialSelectedAddon.data",
    ""
  );
  const planService = getStateData(
    store,
    "api.planService.data.associatedProductVariants",
    []
  );
  const selectedPlan = find(planService, { sku: selectedPlanId });
  
  if (!selectedPlan) return {};

  const { price = 0, discountedPrice = 0, benefits = [] } = selectedPlan;
  const discountApplied =
    price - discountedPrice > 0 ? price - discountedPrice : "No";
  const numOfPromotions = benefits.filter((item) => item.type === "PROMOTION")
    .length;

  return {
    plan_id: selectedPlan.sku,
    plan_amount: price,
    discountApplied,
    numOfPromotions,
  };
};

const getSimType = data => {
  const simType = get(data, "formValues.sim_type");
  const lowerCaseSimType = simType ? lowerCase(simType) : "";
  if (lowerCaseSimType === lowerCase(get(SIM_TYPES, "E_SIM", ""))) {
    return lowerCase(get(SIM_TYPES, "ESIM", ""));
  }
  return lowerCaseSimType;
};

const getLockedNumber = store => {
  return lowerCase(getStateData(store, "api.lockedNumber.data.number", ""));
};

const getNumberType = data => {
  const numberType = get(
    data,
    "formValues.number_type",
    get(data, "number_type")
  );
  const lowerCaseNumberType = numberType ? lowerCase(numberType) : "";
  if (lowerCaseNumberType === lowerCase(get(CONTRACT_TYPES, "NEW"))) {
    return lowerCase(get(CONTRACT_ITEM_TYPES, "NEW_NUMBER"));
  }
  return lowerCaseNumberType;
};

const getSimAndNumberType = store => {
  const formData = getStateData(
    store,
    `form.${forms.CONNECTION_DETAILS_FORM}.values`,
    {}
  );
  return {
    sim_type: lowerCase(formData?.sim_type),
    number_type: lowerCase(formData?.number_type)
  };
};

const handlePageVisit = (currentPath, reduxStore) => {
  const pageEventMap = {
    [get(paths, "PRE_CHECKOUT").replace(ROOT_CHANNEL, WEB_CHANNEL)]: {
      name: EVAM_EVENT_NAMES.PLAN_LISTING_PAGE
    },
    [get(paths, "ADDON_SELECTION").replace(ROOT_CHANNEL, WEB_CHANNEL)]: {
      name: EVAM_EVENT_NAMES.PLAN_DETAILS_PAGE,
      properties: { ...getPlanDetails(reduxStore) }
    },
    [get(paths, "PERSONAL_DETAILS").replace(ROOT_CHANNEL, WEB_CHANNEL)]: {
      name: EVAM_EVENT_NAMES.BEGIN_CHECKOUT,
      properties: { ...getPlanDetails(reduxStore) }
    },
    [get(paths, "PAYMENT_SUCCESS", "").replace(ROOT_CHANNEL, WEB_CHANNEL)]: {
      name: EVAM_EVENT_NAMES.ORDER_CONFIRMATION,
      properties: {
        customer_id: getStateData(
          reduxStore,
          "api.loggedInUserDetails.data.external_id",
          ""
        ),
        order_id: getStateData(reduxStore, "api.order.data.orderReference", "")
      }
    },
    [get(paths, "MANAGE_MANUAL_EKYC", "")]: {
      name: EVAM_EVENT_NAMES.KYC_STARTED
    },
    [get(paths, "ORDER_SUMMARY", "").replace(ROOT_CHANNEL, WEB_CHANNEL)]: {
      name: EVAM_EVENT_NAMES.VIEW_REVIEW_ORDER,
    }, 
  };

  const pageEvent = pageEventMap[currentPath];
  if (pageEvent) {
    return { name: pageEvent.name, properties: pageEvent.properties || {} };
  }

  if (
    currentPath.includes(
      get(paths, "RESCHEDULE_DELIVERY", "").replace(":order_type?", "")
    )
  ) {
    return {
      name: EVAM_EVENT_NAMES.TAP,
      properties: {
        item_name: "Reschedule Delivery",
        item_location: getCurrentUrl()
      }
    };
  }

  if (
    currentPath.includes(
      get(paths, "MANAGE_SIM_ACTIVATION")
    )
  ) {
    
    const eventName = isEmpty(urlParam("iccid"))
    ? EVAM_EVENT_NAMES.ACTIVATE_SIM_PRE_ICCID
    : EVAM_EVENT_NAMES.SCAN_ICCID;
    
    return { name: eventName, properties: {} };
    
  }

  const isPushEPSavedEvent = () => {
    const isEpSaved = getStateData(
      reduxStore, "api.savedcardpayment.data.paymentMethods", []
    ).filter(item => item.name === "EasyPaisa Wallet" && item.instrumentId)

    return !isEmpty(isEpSaved) && currentPath.includes(
      get(paths, "ORDER_SUMMARY", "").replace(ROOT_CHANNEL, WEB_CHANNEL)
    ) && !isEmpty(getAndRemoveItem("epbinding"))
  }

  if ( isPushEPSavedEvent() ) {
    return {
      name: EVAM_EVENT_NAMES.CLICK_EASYPAISA_LINK_ACCOUNT_SAVED,
      properties: {}
    };
  }
  return { name: "", properties: {} };
};

const eventHandlers = {
  page_visit: (_, reduxStore) => handlePageVisit(getCurrentPath(), reduxStore),
  eligiblePlans_api_call_succeeded: () => ({
    name: EVAM_EVENT_NAMES.PLAN_LISTING_PAGE
  }),
  suggestedAddons_api_call_requested: (data, reduxStore) => ({
    name: EVAM_EVENT_NAMES.PLAN_SELECTED,
    properties: {
      plan_type: get(data, "plan_name"),
      ...getPlanDetails(reduxStore)
    }
  }),
  sim_type_selected: (data, reduxStore) => {
    const simType = getSimType(data).replace(/\s+/g, "");
    const simTypes = { esim: "eSIM", physicalsim: "pSIM" };
    return {
      name: `${EVAM_EVENT_NAMES.SIM_SELECTED}_${simTypes[simType]}`,
      properties: { sim_type: simType, ...getPlanDetails(reduxStore) },
      plan_id: get(userSelectedPlan(reduxStore), "sku"),
      amount: get(userSelectedPlan(reduxStore), "price")
    };
  },
  number_type_selected: (data, reduxStore) => {
    const numberType = lowerCase(getNumberType(data)).replace(/\s+/g, "");
    const numberTypes = { portin: "portin", newnumber: "new" };
    return {
      name: `${EVAM_EVENT_NAMES.NUMBER_TYPE_SELECTED}_${numberTypes[numberType]}`,
      properties: { 
        number_type: numberType,
        sim_type: data?.formValues?.sim_type,
        plan_id: get(userSelectedPlan(reduxStore), "sku"),
        amount: get(userSelectedPlan(reduxStore), "price"),
       }
    };
  },
  number_category_selected: (data, reduxStore) => {
    const simType = data?.formValues?.sim_type
    let categoryType = lowerCase(get(data, "formValues.number_category", ""));
    const category = { standard: "free", premium: "premium" };
    categoryType = category[categoryType] || categoryType;
    return {
      name: `${EVAM_EVENT_NAMES.NUMBER_CATEGORY_SELECTED}_${categoryType}`,
      properties: {
        number_type: getNumberType(data).replace(/\s+/g, ""),
        selected_number: getLockedNumber(reduxStore),
        plan_id: get(userSelectedPlan(reduxStore), "sku"),
        category_name: categoryType,
        amount: get(userSelectedPlan(reduxStore), "price"),
        sim_type: simType,
      }
    };
  },
  number_subcategory_selected: (data, reduxStore) => {
    const subCategory = lowerCase(
      getStateData(reduxStore, "api.selectedNumberCategory.data", "")
    );
    return {
      name: `${EVAM_EVENT_NAMES.NUMBER_SUBCATEGORY_SELECTED}_${subCategory}`,
      properties: {
        number_type: getNumberType(data).replace(/\s+/g, ""),
        selected_number: getLockedNumber(reduxStore),
        category_name: subCategory,
        plan_id: get(userSelectedPlan(reduxStore), "sku"),
        amount: get(userSelectedPlan(reduxStore), "price"),
        sim_type: data?.formValues?.sim_type,
      }
    };
  },
  lockedNumber_api_call_succeeded: (data, reduxStore) => {
    const subCategory = lowerCase(
      getStateData(reduxStore, "api.selectedNumberCategory.data", "")
    );
    return {
      name: EVAM_EVENT_NAMES.NUMBER_SELECTED,
      properties: {
        number_type: getNumberType(data).replace(/\s+/g, ""),
        selected_number: getLockedNumber(reduxStore),
        category_name: subCategory,
        plan_id: get(userSelectedPlan(reduxStore), "sku"),
        amount: get(userSelectedPlan(reduxStore), "price"),
      }
    };
  },
  refresh_number: data => ({
    name: EVAM_EVENT_NAMES.REFRESH_NUMBER,
    properties: { refresh_count: get(data, "refreshCount") }
  }),
  telco_selected: data => ({
    name: EVAM_EVENT_NAMES.DONOR_TELCO_SELECTED,
    properties: { telco: get(data.formValues, `${data.field}.label`) }
  }),
  validatePortInNumber_api_call_succeeded: (_, reduxStore) => ({
    name: getStateData(reduxStore, "api.validatePortInNumber.data.valid")
      ? EVAM_EVENT_NAMES.PORT_IN_NUMBER_ENTERTED
      : "",
    properties: {
      portin_number: getStateData(
        reduxStore,
        "api.validatePortInNumber.params.msisdn",
        ""
      )
    }
  }),
  e_sim_consent_disclaimer_selected: data => ({
    name: EVAM_EVENT_NAMES.ESIM_CONSENT_CHECK,
    properties: {
      esim_consent_provided: get(data, "formValues.e_sim_consent_disclaimer")
    }
  }),
  newProfileParameters_api_call_succeeded: () => ({
    name:
      window.location.pathname ===
      get(paths, "PERSONAL_DETAILS").replace(ROOT_CHANNEL, WEB_CHANNEL)
        ? EVAM_EVENT_NAMES.PERSONAL_PAGE_VIEW
        : "",
    properties: {}
  }),
  shippingMethods_api_call_requested: (_, reduxStore) => ({
    name:
      window?.location?.pathTracking?.previous ===
      get(paths, "CONNECTION_DETAILS").replace(ROOT_CHANNEL, WEB_CHANNEL)
        ? EVAM_EVENT_NAMES.CONNECTION_DETAILS_PAGE_NEXT
        : "",
    properties: { ...getSimAndNumberType(reduxStore) }
  }),
  // PersonalDetailsForm_submitted: data => ({
  //   name: EVAM_EVENT_NAMES.USER_DETAILS_SUBMITTED,
  //   properties: removeSensitiveData(flattenData(get(data, "formValues", {})))
  // }),
  referralCode_api_call_succeeded: data => ({
    name: EVAM_EVENT_NAMES.PROMOCODE_USED,
    properties: {
      promocode: get(data, "referral_code", ""),
      promocode_type: get(data, "referral_code_type", ""),
      promo_campaign: get(data, "title", ""),
      benefits: get(data, "benefits", []).reduce(
        (acc, current) => `${current.title}${acc ? `,${acc}` : ""}`,
        ""
      )
    }
  }),
  numberAndDeliverySlotsAvailability_api_call_succeeded: data => ({
    name: EVAM_EVENT_NAMES.ORDER_SUMMARY_COMPLETED,
    properties: {
      plan_type: get(data, "planService.productCategory"),
      plan_name: data.plan_name,
      addon_selected: map(
        data.userSelectedAddons,
        addon => get(addon, "title"),
        []
      ).join(", "),
      promocode_used: data.referral_code
    }
  }),
  payment_method_selected: data => ({
    name: EVAM_EVENT_NAMES.PAYMENT_SELECTED,
    properties: { payment_type: get(data, "formValues.payment_method.code") }
  }),
  paymentStatus_api_call_requested: (data, reduxStore) => {

    const amount = getStateData(reduxStore, "api.order.data.cost.amount", "");

    const flowInfo = getStateData(reduxStore, "api.flowInfo.data.from", "");
    const orderID = getStateData(reduxStore, "api.paymentRequest.data.external_id", "");
    if (orderID?.startsWith("CXR") || flowInfo === JOURNEY_FLOW.RESCHDEULE_DELIVERY || isEpBind()) return;

    const pid =
      getStateData(reduxStore, "api.initialSelectedAddon.data", "") ||
      getItem("evam_in_app_pid");
    const planValidityInApp = getItem("evam_in_app_validity")
      const planValidity = calculateValidityAndExpiry(reduxStore);
    const payment_method = getStateData(
      reduxStore,
      "api.paymentRequest.data.gateway",
      ""
    );

    const isEventPushed = getItem(`evamPyamentPending_${data?.core_transaction_id}`);
    if (!isEventPushed) setItem(`evamPyamentPending_${data?.core_transaction_id}`, true);
    
    if(!isEventPushed) {
      return {
        name: EVAM_EVENT_NAMES.PAYMENT_PENDING,
        properties: {
          amount,
          pid,
          payment_method,
          validity: planValidityInApp || planValidity?.validity,
          ...planValidity?.expiry && {expiry: planValidity?.expiry}
        }
      };
    } else {
      return null
    }
    
  },
  paymentStatus_api_call_succeeded: (data, reduxStore) => {

    const flowInfo = getStateData(reduxStore, "api.flowInfo.data.from", "");
    const orderID = getStateData(reduxStore, "api.paymentRequest.data.external_id", "");
    if (orderID?.startsWith("CXR") || flowInfo === JOURNEY_FLOW.RESCHDEULE_DELIVERY || isEpBind()) return;
    
    const { payment_status, message, payment_options } = data;
    const psp_ref = payment_options?.psp_reference
    const evamPaymentSuccess = getItem(`evamPaymentSuccess_${psp_ref}`);
    const evamPaymentFailed = getItem(`evamPaymentFailed_${psp_ref}`);
    const planValidityInApp = getItem("evam_in_app_validity")
    const planValidity = calculateValidityAndExpiry(reduxStore);
    const pid =
      getStateData(reduxStore, "api.initialSelectedAddon.data", "") ||
      getItem("evam_in_app_pid");
    
    const lowerCasePaymentStatus = lowerCase(payment_status);
    if (lowerCasePaymentStatus === 
      lowerCase(get(PAYMENT_STATUSES_CXOS, "SUCCESS")) &&
      !evamPaymentSuccess
    ) {
      setItem(`evamPaymentSuccess_${psp_ref}`, true)
      return {
        name: EVAM_EVENT_NAMES.PURCHASE,
        properties: {
          status: lowerCasePaymentStatus,
          amount: data?.order?.cost?.amount,
          pid: pid,
          payment_method: payment_options?.gateway,
          validity: planValidityInApp || planValidity?.validity,
          ...planValidity?.expiry && {expiry: planValidity?.expiry}
        }
      };
    }
    if (
      (lowerCasePaymentStatus ===
        lowerCase(get(PAYMENT_STATUSES_CXOS, "FAILURE"))) &&
        !evamPaymentFailed
    ) {
      setItem(`evamPaymentFailed_${psp_ref}`, true)
      return {
        name: EVAM_EVENT_NAMES.PAYMENT_FAILURE,
        properties: {
          status: lowerCasePaymentStatus,
          amount: data?.order?.cost?.amount,
          pid: pid,
          payment_method: payment_options?.gateway,
          failure_error_reason: message,
          validity: planValidityInApp || planValidity?.validity,
          ...planValidity?.expiry && {expiry: planValidity?.expiry}
        }
      };
    }
    return { name: "", properties: {} };
  },
  order_api_call_succeeded: (data, reduxStore) => {

    const flowInfo = getStateData(reduxStore, "api.flowInfo.data.from", "");
    const orderID = getStateData(reduxStore, "api.paymentRequest.data.external_id", "");
    if (orderID?.startsWith("CXR") || flowInfo === JOURNEY_FLOW.RESCHDEULE_DELIVERY || isEpBind()) return;

    const { state, substates } = data;
    const evamPlaceOrderSuccess = getItem("evamPlaceOrderSuccess");
    const pid =
      getStateData(reduxStore, "api.initialSelectedAddon.data", "")
    const planValidity = calculateValidityAndExpiry(reduxStore);

    if (
      state === ORDER_STATUS.PLACED && 
      !evamPlaceOrderSuccess && 
      substates?.PAYMENT?.status === "NOT_APPLICABLE"
    ) {
      setItem("evamPlaceOrderSuccess")
      return {
        name: EVAM_EVENT_NAMES.PURCHASE,
        properties: {
          status: state,
          amount: 0,
          pid: pid,
          validity: planValidity?.validity,
          expiry: planValidity?.expiry
        }
      };
    }
    return { name: "", properties: {} };
  },
  selectedPaymentOption_requested: (data, reduxStore) => {
    const isRecurrentSelected = getStateData(
      reduxStore,
      "api.selectedPaymentOption.data.recurring_txn"
    );

    return {
      name: isRecurrentSelected
        ? EVAM_EVENT_NAMES.CLICK_CARDS_WITH_SAVE_METHOD
        : EVAM_EVENT_NAMES.PAYMENT_METHOD_POPUP,
      properties: {},
    };
  },
  payment_type_selected: (data, reduxStore) => {
    const selectedPaymentMethod = getStateData(
      reduxStore,
      "api.selectedPaymentOption.data.transaction_instrument_name"
    );

    const paymentEventMap = {
      card_text: EVAM_EVENT_NAMES.CLICK_CARDS,
      jazzcash_text: EVAM_EVENT_NAMES.CLICK_JAZZCASH,
      all_mobile_wallets_text: EVAM_EVENT_NAMES.CLICK_ALL_MOBILE_WALLET,
      bank_account_text: EVAM_EVENT_NAMES.CLICK_BANK_ACCOUNT,
      unionpay_text: EVAM_EVENT_NAMES.CLICK_OTHER,
      paypak_text: EVAM_EVENT_NAMES.CLICK_OTHER,
      link_account_text:
        selectedPaymentMethod === "easypaisa_text"
          ? EVAM_EVENT_NAMES.CLICK_EASYPAISA_LINK_ACCOUNT
          : "",
      one_time_payment_text:
        selectedPaymentMethod === "easypaisa_text"
          ? EVAM_EVENT_NAMES.CLICK_EASYPAISA_ONETIME
          : "",
    };

    const eventName = paymentEventMap[data?.selected] || "";

    return {
      name: eventName,
      properties: {},
    };
  },
  jazzcash_onetime_popup_requested: () => {
    return {
      name: EVAM_EVENT_NAMES.VIEW_JAZZCASH_INPUT_PAGE,
      properties: {},
    };
  },
  update_sync_errors: (data) => {
    const getEvent = () => {
      if (
        data?.form === forms.SIM_VERIFICATION_FORM &&
        isEmpty(data?.formSyncErrors?.icc_id) &&
        !isEmpty(data?.formValues?.icc_id) &&
        isEmpty(urlParam("iccid"))
      ) {
        return EVAM_EVENT_NAMES.ENTER_ICCID;
      }
    };
    return {
      name: getEvent(),
      properties: {},
    };
  },
  activateSimCard_api_call_requested: (data, reduxStore) => {
    const orderList = getStateData(reduxStore, "api.userOrders.data", []);
    const mobileNumber = orderList.find(
      (order) => order?.order_ref === data?.orderRef
    )?.selected_number;

    return {
      name: EVAM_EVENT_NAMES.ACTIVATE_SIM_POST_ICCID,
      properties: {
        iccid: data?.iccid,
        mobileNumber: mobileNumber || "",
        simType: isEmpty(data?.iccid) ? SIM_TYPES.ESIM : SIM_TYPES.PHYSICAL_SIM,
      },
    };
  },
  activateSimCard_api_call_failed: () => {
    return {
      name: EVAM_EVENT_NAMES.ACTIVATION_STATUS,
      properties: {
        status: "failed",
      },
    };
  },
  activateSimCard_api_call_succeeded: () => {
    return {
      name: EVAM_EVENT_NAMES.ACTIVATION_STATUS,
      properties: {
        status: "success",
      },
    };
  },
  easypaisa_onetime_popup_requested: () => {
    return {
      name: EVAM_EVENT_NAMES.VIEW_EASYPAISA_INPUT_PAGE,
      properties: {},
    };
  },
  paymentMethodInstrument_api_call_failed: () => {
    if(!isEmpty(getAndRemoveItem("epbinding"))) {
      return {
        name: EVAM_EVENT_NAMES.CLICK_EASYPAISA_LINK_ACCOUNT_SAVED_ERROR,
        properties: {},
      };
    }
  },
  userLoginOTP_api_call_succeeded: () => {
    return {
      name: EVAM_EVENT_NAMES.WEB_LOGIN_EVENT,
      properties: {},
    };
  },
  userLogout_api_call_requested: () => {
    return {
      name: EVAM_EVENT_NAMES.WEB_LOGOUT_EVENT,
      properties: {},
    };
  },
  location_consent_given: (_, reduxStore) => {
    const locationInfo = getStateData(
      reduxStore,
      "api.locationconsentgiven.data",
      {}
    );
    const eventName = isEmpty(locationInfo) 
        ? EVAM_EVENT_NAMES.WEB_LOCATION_TOGGLE_OFF 
        : EVAM_EVENT_NAMES.WEB_LOCATION_TOGGLE_ON;

    return { name: eventName, properties: {} };
  },
  delivery_area_selected: (data) => {
    const { field } = data;
    const delivery_area = get(data, "formValues.delivery_area.value");
    if (field === "delivery_area" && delivery_area) {
      return {
        name: EVAM_EVENT_NAMES.SELECT_AREA,
        properties: {
          area: delivery_area,
        },
      };
    }
  },
  delivery_city_selected: (data) => {
    const { field } = data;
    const delivery_city = get(data, "formValues.delivery_city.value");
    if (field === "delivery_city" && delivery_city) {
      return {
        name: EVAM_EVENT_NAMES.SELECT_CITY,
        properties: {
          city: delivery_city,
        },
      };
    }
  },
  delivery_province_selected: (data) => {
    const { field } = data;
    const delivery_province = get(data, "formValues.delivery_province.value");
    if (field === "delivery_province" && delivery_province) {
      return {
        name: EVAM_EVENT_NAMES.SELECT_PROVINCE,
        properties: {
          province: get(data, "formValues.delivery_province.value"),
        },
      };
    }
  },
  delivery_slot_full_data_selected: (data) => {
    const { field } = data;
    const delivery_slot_full_data = get(data, "formValues.delivery_date");
    if (field == "delivery_slot_full_data") {
      return {
        name: EVAM_EVENT_NAMES.SELECT_SLOT_DATE,
        properties: {
          selectedSlotDate: delivery_slot_full_data,
        },
      };
    }
  },
  delivery_slot_selected: (data) => {
    const { field } = data;
    const delivery_slot_start = get(data, "formValues.delivery_start_time");
    const delivery_slot_end = get(data, "formValues.delivery_end_time");
    if (field === "delivery_slot" && delivery_slot_start && delivery_slot_end) {
      return {
        name: EVAM_EVENT_NAMES.SELECT_SLOT_TIME,
        properties: {
          selectedSlotTime: `${delivery_slot_start}-${delivery_slot_end}`,
        },
      };
    }
  },
  requestGuestOtt_api_call_succeeded: () => {
    const isEmailValidated = localStorage.getItem("isEmailValidated");
    if (isEmailValidated) {
      return {
        name: EVAM_EVENT_NAMES.CLICK_VERIFY_EMAIL,
        properties: {},
      };
    }
  },
  validateGuestOtt_api_call_succeeded: () => {
    const isEmailValidated = localStorage.getItem("isEmailValidated");
    if (isEmailValidated) {
      return {
        name: EVAM_EVENT_NAMES.OTP_VERIFIED,
        properties: {
          status:"success"
        },
      };
    }
  },
  validateGuestOtt_api_call_failed: () => {
    const isEmailValidated = localStorage.getItem("isEmailValidated");
    if (isEmailValidated) {
      return {
        name: EVAM_EVENT_NAMES.OTP_VERIFIED,
        properties: {
          status:"failure"
        },
      };
    }
  },
  field_blurred: (data) => {
    const { field, formSyncErrors } = data;
    const identificationNumberField = get(FIELDS_TO_TRACK, "IDENTIFICATION_NUMBER");
    const reidentificationNumberField = get(FIELDS_TO_TRACK, "CONFIRM_IDENTIFICATION_NUMBER");
    const hasConfirmCNICValidationError = formSyncErrors[identificationNumberField];
    const hasIdentificationNumberFieldValidationError = formSyncErrors[reidentificationNumberField];
    const eventMapping = {
      "first_name": {
        name: EVAM_EVENT_NAMES.ENTER_FIRST_NAME,
        properties: { first_name: get(data, "formValues.first_name") },
      },
      "last_name": {
        name: EVAM_EVENT_NAMES.ENTER_LAST_NAME,
        properties: { last_name: get(data, "formValues.last_name") },
      },
      "contact_number": {
        name: EVAM_EVENT_NAMES.ENTER_ALT_NUMBER,
        properties: { contact_number: get(data, "formValues.contact_number") },
      },
      "delivery_address_line_1": {
        name: EVAM_EVENT_NAMES.ADDRESS_LINE1,
        properties: {},
      },
      "email": data?.formSyncErrors?.email === undefined && {
        name: EVAM_EVENT_NAMES.ENTER_EMAIL,
        properties: { email: get(data, "formValues.email") },
      },
      "identification_number": !hasConfirmCNICValidationError && {
        name: EVAM_EVENT_NAMES.CNIC_SUBMITTED,
        properties: { cnic: get(data, "formValues.identification_number") },
      },
      "reConfirmidentificationNumber": !hasIdentificationNumberFieldValidationError && !hasConfirmCNICValidationError && {
        name: EVAM_EVENT_NAMES.RE_ENTER_CNIC,
        properties: { cnic: get(data, "formValues.reConfirmidentificationNumber") },
      }
    };
    return eventMapping[field] || undefined;
  },

  apply_promo_code: () => ({ name: EVAM_EVENT_NAMES.CLICK_APPLY_PROMO, properties: {} }),
  summary_edit_button: () => ({ name: EVAM_EVENT_NAMES.CLICK_EDIT_INFO, properties: {} }),
  PersonalDetailsForm_submitted: () => ({ name: EVAM_EVENT_NAMES.DETAILS_PAGE_NEXT, properties: {} }),
  addConsentRecord_api_call_requested: (data, reduxStore) => {
    const paymentType = getStateData(
      reduxStore,
      "api.payUsingMethod.data.payment_partner",
      ""
    );
    const instrument_id = getStateData(
      reduxStore,
      "api.payUsingMethod.data.instrument_id",
      ""
    );
    if (paymentType == "easypaisa wallet" && instrument_id) {
      return {
        name: EVAM_EVENT_NAMES.CLICK_MAKE_PAYMENT_SAVEDMETHOD_EP,
        properties: {},
      };
    }
    if (paymentType == "payfast" && instrument_id) {
      return {
        name: EVAM_EVENT_NAMES.CLICK_MAKE_PAYMENT_SAVEDMETHOD_CARDS,
        properties: {},
      };
    }
  },
  dobYear_selected: (data) => ( validateDOBPushEvent(get(data, "formValues.dob", "")) ? null : {
    name: EVAM_EVENT_NAMES.ENTER_DOB,
    properties: { dob: get(data, "formValues.dob") },
  }),
  dob_selected: (data) => ( validateDOBPushEvent(get(data, "formValues.dob", "")) ? null : {
    name: EVAM_EVENT_NAMES.ENTER_DOB,
    properties: { dob: get(data, "formValues.dob") },
  }),
  age_selected: (data) => ( validateDOBPushEvent(get(data, "formValues.dob", "")) ? null : {
    name: EVAM_EVENT_NAMES.ENTER_DOB,
    properties: { dob: get(data, "formValues.dob") },
  }),
  promocodeOrderPreview_api_call_requested: () => ({
    name: EVAM_EVENT_NAMES.CLICK_APPLY_PROMO,
    properties: {},
  }),
  promo_enter: (data) => ({
    name: EVAM_EVENT_NAMES.ENTER_PROMO_CODE,
    properties: { promo: data.promoCode },
  }),
  select_payment_option_requested:()=> ({
    name: EVAM_EVENT_NAMES.CLICK_MAKE_PAYMENT,
    properties: {  },
  }),
  show_max_connection_modal_requested:()=> ({
    name: EVAM_EVENT_NAMES.MAX_5_SIM_POPUP,
    properties: {  },
  }),
};

export const constructEvamEventInfo = (event, data, reduxStore) => {
  const handler = eventHandlers[event];
  let evamEventProperties = handler
    ? handler(data, reduxStore)
    : removeSensitiveData(flattenData(data));

  const dateTime = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZone: "Asia/Singapore"
  };
  const formattedDateTime = dateTime.toLocaleString("en-US", options);
  evamEventProperties = {
    ...evamEventProperties,
    properties: {
      ...(evamEventProperties?.properties || {}),
      device_id: Session.getDeviceId(),
      cxu_id: getStateData(reduxStore, "api.userAuthenticate.data.userId", "") || 
        getStateData(reduxStore, "api.loggedInUserDetails.data.external_id", ""),
      session_id: Session.getDeviceId(),
      browser_name: getBrowserName(),
      date_and_time: formattedDateTime,
      channel: getChannel(),
      timestamp: new Date().getTime(),
      timespent_by_user_onpage: timeSpentOnPageTilltheEvent(),
      ...getOSInfo()
    }
  };
  return {
    event: evamEventProperties
  };
};
